import clsx from 'clsx';
import React from 'react';

import IconWave from '@components/Images/IconWave';
import ListenButton from '@components/ListenButton';
import { ContentType } from '@tracking';

interface AudioSectionProps {
  mainContainerClassName?: string;
}
const AudioSection = ({ mainContainerClassName }: AudioSectionProps) => {
  return (
    <article
      className={clsx(
        'relative mx-0 max-w-full overflow-hidden border-b border-grayscale-beige pb-80 pt-64 text-left sm:pb-[140px] sm:pt-112 md:max-w-[900px] lg:mx-auto lg:max-w-[900px] lg:text-center',
        mainContainerClassName
      )}
    >
      <header className="flex flex-col items-center justify-center gap-16 sm:gap-32">
        <div className="pointer-events-none w-full">
          <ListenButton
            isAudioActive={true}
            setIsAudioActive={() => {}}
            contentType={ContentType.Article}
          />
        </div>
        <h2 className="mb-0 mt-8 w-full font-suisse-works text-headline-xxs text-primary-black sm:text-headline-sm md:text-headline-md">
          No Time to Read? Press Play.
        </h2>
      </header>
      <p className="m-0 mx-0 max-w-full font-suisse-neue text-body-lg text-primary-black lg:mx-auto lg:max-w-[560px]">
        Our scoops and analysis, now in audio, so you can stay informed wherever your day takes you.{' '}
      </p>
      <small className="mt-8 font-suisse-intl-mono text-overline-md font-normal">
        Listen on mobile and desktop
      </small>
      <IconWave
        className="absolute bottom-0 left-1/2 hidden h-[246px] w-[300px] -translate-x-1/2 translate-y-1/2 text-grayscale-charcoal/10 *:stroke-[2] sm:h-[360px] sm:w-[540px] lg:block"
        preserveAspectRatio="xMidYMax meet"
      />
    </article>
  );
};

export default AudioSection;
